import { useRef, useState } from 'react';

import { Box, Divider, Flex, Image } from '@chakra-ui/react';
import WarningTextMessage from '../../global/components/helper-components/components/WarningTextMessage';
import PageLoader from '../../global/components/helper-components/components/PageLoader';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import { useHistory } from 'react-router-dom';
import LaunchdeckFormInput from '../../forms/TextInputField/components/LaunchdeckFormInput';


export default function SetupProfileGenesisForm({ userProfile, orgProfile, handleSetupGenesisProfile }) {

	const formChangedRef = useRef(false);
	const history = useHistory()

	const [showValidationError, setShowValidationError] = useState(false)
	const [showLoader, setShowLoader] = useState(false);

	const [localUserProfileState, setUserProfileLocalState] = useState({
		firstName: userProfile.firstName,
		lastName: userProfile.lastName,
		userIdToken: userProfile.idToken
	})
	const [localUserOrgProfileState, setUserOrgProfileLocalState] = useState({
		orgRegisteredAddress: orgProfile.orgRegisteredAddress,
		orgRegisteredCountry: orgProfile.orgRegisteredCountry,
		orgName: orgProfile.orgName,
		orgLogo: orgProfile.orgLogo
	})


	const handleChange = (event) => {
		const name = event.target.name;
		const value = event.target.value;

		if (name === "firstName" || name === "lastName") {
			setUserProfileLocalState(localUserProfileState => ({
				...localUserProfileState,
				[event.target.name]: value
			}));

			!!showValidationError && setShowValidationError(false)

			formChangedRef.current = true
		} else if (name === "orgName" || name === "orgRegisteredCountry" || name === "orgRegisteredAddress") {

			setUserOrgProfileLocalState(localUserOrgProfileState => ({
				...localUserOrgProfileState,
				[event.target.name]: value
			}));

			!!showValidationError && setShowValidationError(false)

			formChangedRef.current = true
		}

	}

	const handleSaveGenesisProfile = () => {
		const { firstName, lastName } = localUserProfileState;

		if (firstName && lastName) {
			// Go to homepage if no changes
			if (!formChangedRef.current) {
				history.push(`/home`, {})
			} else {
				setShowLoader(true)
				handleSetupGenesisProfile({ useCase: 'setup-user-and-org-info', userProfileInput: localUserProfileState, userOrgProfileInput: localUserOrgProfileState })
			}
		} else {
			setShowValidationError(true)
		}
	}


	if (showLoader) {
		return (
			<PageLoader />
		)
	} else {
		const { firstName, lastName } = localUserProfileState || {};
		const { orgLogo, orgName, orgRegisteredAddress, orgRegisteredCountry } = localUserOrgProfileState || {};

		return (
			<>

				<Box mt={['1em', '0.5em']} display={['auto', 'none']}>
					<Divider />
				</Box>
				<Flex w='100%' justify='space-between' align='center' my='1em'>
					<Box fontSize='1em' letterSpacing='1px' color='brandDark.500' textAlign='left'>ABOUT YOU</Box>
				</Flex>

				<Box mb='2em' w='100%'>
					<Flex w='100%' direction={['column', 'row']} gap='1em' justify='space-between' align='flex-start'>
						<Box flex='1' w='100%'>
							<LaunchdeckFormInput
								label='First Name'
								name={'firstName'}
								onChange={handleChange}
								value={firstName || ""}
								errorLogic={showValidationError}
							/>

						</Box>

						<Box flex='1' w='100%'>
							<LaunchdeckFormInput
								label='Last Name'
								name={'lastName'}
								onChange={handleChange}
								value={lastName || ""}
								errorLogic={showValidationError}
							/>

						</Box>
					</Flex>
				</Box>


				<Divider />

				<Flex w='100%' justify='space-between' align='center' mt={['1em', '1em', '2em', '2em']} mb='0.5em'>
					<Box textAlign='left'>
						<Box fontSize='1em' letterSpacing='1px' color='brandDark.500' textAlign='left'>ABOUT YOUR TEAM</Box>
					</Box>
				</Flex>

				<Flex my='1em' w='100%' direction={['column', 'row']} gap='1.5em'>
					{orgLogo && <Flex flex='3' direction='column' justify='center' align='center'>
						<Image height={'5em'} src={orgLogo} />
						{/* <Box fontSize='0.8em' color='gray.500' px='1em' mt='3em' textAlign='center' display={['none', 'none', 'block', 'block']}>
							<Box>Prefer another logo? </Box>
							<Box>Change it in your account settings at any time</Box>
						</Box> */}
					</Flex>}

					<Flex direction='column' gap='1em' flex='7'>

						<LaunchdeckFormInput
							label='Company name'
							name={'orgName'}
							onChange={handleChange}
							value={orgName || ""}
						/>


						<LaunchdeckFormInput
							label='Country registered in'
							name={'orgRegisteredCountry'}
							onChange={handleChange}
							value={orgRegisteredCountry || ""}
						/>

						<LaunchdeckFormInput
							label='Registered address'
							name={'orgRegisteredAddress'}
							onChange={handleChange}
							value={orgRegisteredAddress || ""}
						/>

					</Flex>
				</Flex>

				<Box mt='3em'>
					<WarningTextMessage fontSize='0.8em' errorLogic={showValidationError} message='Please provide your names to proceed' />
					<LaunchdeckButton bg='brand.500' color='white' px='2em' w='100%' maxW='inherit' fontSize='1em' onClick={() => handleSaveGenesisProfile()} label='Looks good' />
				</Box>
			</>
		)
	}
};